const aiReceptionistBase = 'ai-receptionist';

export const AiReceptionistTrackingIds = {
  infoModalOpenLink: `${aiReceptionistBase}-info-modal-open-link`,
  infoModalCloseButton: `${aiReceptionistBase}-info-modal-close-button`,
  instructionsMessagingVoiceLink: `${aiReceptionistBase}-instructions-messaging-voice-link`,
  instructionsSchedulingLink: `${aiReceptionistBase}-instructions-scheduling-link`,
  knowledgeBaseBusinessLink: `${aiReceptionistBase}-knowledge-base-business-link`,
  knowledgeBasePaymentsLink: `${aiReceptionistBase}-knowledge-base-payments-link`,
  knowledgeBaseScheduleLink: `${aiReceptionistBase}-knowledge-base-schedule-link`,
  knowledgeBaseCustomLink: `${aiReceptionistBase}-knowledge-base-custom-link`,
  personalNotificationsLink: `${aiReceptionistBase}-personal-notifications-link`,
  schedulingInstructionSaveButton: `${aiReceptionistBase}-scheduling-instruction-save-button`,
  schedulingInstructionCancelButton: `${aiReceptionistBase}-scheduling-instruction-cancel-button`,
  schedulingInstructionMultiDoneButton: `${aiReceptionistBase}-scheduling-instruction-multi-done-button`,
  businessKnowledgeSaveButton: `${aiReceptionistBase}-business-knowledge-save-button`,
  businessKnowledgeCancelButton: `${aiReceptionistBase}-business-knowledge-cancel-button`,
  businessKnowledgeMultiDoneButton: `${aiReceptionistBase}-business-knowledge-multi-done-button`,
  businessKnowledgeManageAllButton: `${aiReceptionistBase}-business-knowledge-manage-all-button`,
  paymentsKnowledgeSaveButton: `${aiReceptionistBase}-payments-knowledge-save-button`,
  paymentsKnowledgeCancelButton: `${aiReceptionistBase}-payments-knowledge-cancel-button`,
  paymentsKnowledgeMultiDoneButton: `${aiReceptionistBase}-payments-knowledge-multi-done-button`,
  paymentsKnowledgeManageAllButton: `${aiReceptionistBase}-payments-knowledge-manage-all-button`,
  scheduleKnowledgeSaveButton: `${aiReceptionistBase}-schedule-knowledge-save-button`,
  scheduleKnowledgeCancelButton: `${aiReceptionistBase}-schedule-knowledge-cancel-button`,
  scheduleKnowledgeMultiDoneButton: `${aiReceptionistBase}-schedule-knowledge-multi-done-button`,
  scheduleKnowledgeManageAllButton: `${aiReceptionistBase}-schedule-knowledge-manage-all-button`,
  customKnowledgeSaveButton: `${aiReceptionistBase}-custom-knowledge-save-button`,
  customKnowledgeCancelButton: `${aiReceptionistBase}-custom-knowledge-cancel-button`,
  customKnowledgeMultiDoneButton: `${aiReceptionistBase}-custom-knowledge-multi-done-button`,
  customKnowledgeManageAllButton: `${aiReceptionistBase}-custom-knowledge-manage-all-button`,
};
